var exports = {
  "X": "BetaLabel__TCb4BE",
};

module.exports = exports;
